import React from "react";
import Loadable from "../../react-loadable";

const WeaTableEdit = Loadable({
  loader: () => import("./TableEdit"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaTableEdit;



// WEBPACK FOOTER //
// ./ecology9/wea-table-edit/index.js